exports = module.exports = require("../../../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".j-array-form[data-v-2f6450a9] .el-form-item__label:before{content:\"\"!important;color:unset!important;margin-right:unset!important}.j-array-form[data-v-2f6450a9] .j-array-form-index.required:before{content:\"*\";color:#f56c6c;margin-right:4px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.28.11@css-loader?minimize!./node_modules/_vue-loader@13.7.3@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2f6450a9","scoped":true,"hasInlineConfig":false}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=styles&index=0!./packages/element-ui-expand/src/JElArrayForm.vue
// module id = 60
// module chunks = 0